import { MutationTree } from 'vuex';
import { ETemplateLibraryMutation } from '@/document-manipulator/create-page/template-library-old/store/template-library-old.constants';
import { ITemplateLibraryState } from '@/document-manipulator/create-page/template-library-old/store/template-library-old.types';
import { IDocument } from '@lib-shared/types/Document';
import { IFolder } from '@/folders/types/folder';
import { IFolderTree } from '@/folders/types/folder-tree';
import { IPagination } from '@/types/Pagination';

export const mutations: MutationTree<ITemplateLibraryState> = {
  [ETemplateLibraryMutation.SetLoading](state: ITemplateLibraryState, loading: boolean) {
    state.loading = loading;
  },
  [ETemplateLibraryMutation.SetLoaded](state: ITemplateLibraryState, loaded: boolean) {
    state.loaded = loaded;
  },
  [ETemplateLibraryMutation.SetTemplates](
    state: ITemplateLibraryState,
    { templates, totalRows }: { templates: IDocument[]; totalRows: number }
  ) {
    state.templates = templates;
    state.pagination = { ...state.pagination, totalRows };
  },
  [ETemplateLibraryMutation.SetPagination](state: ITemplateLibraryState, pagination: IPagination) {
    state.pagination = pagination;
  },
  [ETemplateLibraryMutation.SetFolders](state: ITemplateLibraryState, folders: IFolder[]) {
    state.folders = folders;
  },
  [ETemplateLibraryMutation.SetBreadcrumbs](state: ITemplateLibraryState, breadcrumbs: IFolder[]) {
    state.breadcrumbs = breadcrumbs;
  },
  [ETemplateLibraryMutation.SetFolderTree](state: ITemplateLibraryState, folderTree: IFolderTree) {
    state.folderTree = folderTree;
  },
  [ETemplateLibraryMutation.SetFolderId](state: ITemplateLibraryState, folderId: string) {
    state.folderId = folderId;
  },
  [ETemplateLibraryMutation.SetSearchQuery](state: ITemplateLibraryState, query: string) {
    state.searchQuery = query;
  },
  [ETemplateLibraryMutation.SetState](
    state: ITemplateLibraryState,
    newState: ITemplateLibraryState
  ) {
    state.loading = newState.loading;
    state.loaded = newState.loaded;
    state.folderId = newState.folderId;
    state.templates = newState.templates;
    state.folders = newState.folders;
    state.folderTree = newState.folderTree;
    state.breadcrumbs = newState.breadcrumbs;
    state.pagination = newState.pagination;
    state.searchQuery = newState.searchQuery;
  },
};
